export default __webpack_public_path__ + "static/media/storage-stacks.6dfa2e4c.svg";